import { Box, Center, Text } from '@chakra-ui/react';
import WindArrow from './WindArrow/WindArrow';
import React from 'react';

export default function WeatherCard({ title, data, icon, gustsLabel }) {
  return (
    <Box
      w={['48%', null, null, null, '48%']}
      padding={'5px'}
      m={0}
      h={['160px']}
      bgColor={'#d9d9d926'}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      borderRadius={5}
      overflow="hidden"
    >
      <Box
        display="flex"
        alignItems="center"
        gap={1}
        alignSelf={'flex-start'}
        mb={1}
      >
        {icon && <Box color="gray.500">{icon}</Box>}
        <Text
          textStyle={'weatherCardHeading'}
          textTransform={'uppercase'}
        >
          {title}
        </Text>
      </Box>
      {data === null ? (
        <Text fontSize="xs" color="gray.400">—</Text>
      ) : typeof data === 'object' ? (
        <>
          {(data.windDirection || data.windGusts || data.windSpeed) ? (
            <Center
              display={'flex'}
              flexDirection={'column'}
              alignContent={'center'}
              h={'100%'}
            >
              <Text textStyle={'weatherCardHeading'}>{data.windDirection}</Text>
              <Box
                h={'50px'}
                w={'50px'}
                borderRadius={'50%'}
                border={'1px #000 solid'}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <WindArrow windDirection={data.windDirection} />
              </Box>
              <Text textStyle={'weatherCardHeading'}>
                {data.windSpeed} km/h
              </Text>
              <Text textStyle={'paragraphBody'}>
                {gustsLabel || 'Rachas'} {data.windGusts} km/h
              </Text>
            </Center>
          ) : (
            <Text fontSize="xs" color="gray.400">—</Text>
          )}
        </>
      ) : (
        <Center
          display={'flex'}
          flexDirection={'column'}
          alignContent={'center'}
          h={'100%'}
        >
          <Text textStyle={'weatherCardData'}>{data}</Text>
        </Center>
      )}
    </Box>
  );
}
